import { server, mensajeria } from "../db/api";

export async function newMensajeriaHP(data) {
  console.log("--Mensajeria.helper.newMensajeriaHP--  ", JSON.stringify(data));
  const request = await fetch(`${server}${mensajeria}/create`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(data)
  })
  const response = await request.json();
  console.log("--Mensajeria.helper.newMensajeriaHP-- response: ", response)
  return response
}

export async function getAllMensajeriasHP() {
  console.log("--Mensajeria.helper.getAllMensajeriasHP--  ");
  const request = await fetch(`${server}${mensajeria}/mensajerias`, {
    method: "GET",
    headers: { "content-type": "application/json" }
  })
  const response = await request.json();
  console.log("--Mensajeria.helper.getAllMensajeriasHP-- response: ", response);
  return response
}

export async function getMensajeriaHP(id) {
  console.log("--Mensajeria.helper.getMensajeriaHP--  ");
  console.log("--Mensajeria.helper.getMensajeriaHP--  id: ", id);
  const request = await fetch(`${server}${mensajeria}/mensajeria/${id}`, {
    method: "GET",
    headers: { "content-type": "application/json" }
  })
  const response = await request.json();
  console.log("--Mensajeria.helper.getMensajeriaHP-- response: ", response);
  return response
}

export async function getMeMensajeriasHP(id) {
  console.log("--Mensajeria.helper.getMeMensajeriasHP--  ");
  console.log("--Mensajeria.helper.getMeMensajeriasHP--  id: ", id);
  const request = await fetch(`${server}${mensajeria}/memensajerias/${id}`, {
    method: "GET",
    headers: { "content-type": "application/json" }
  })
  const response = await request.json();
  console.log("--Mensajeria.helper.getMeMensajeriasHP-- response: ", response);
  return response
}

export async function updateMensajeriaHP(id, data) {
  console.log("--Mensajeria.helper.updateMensajeriaHP--  ");
  console.log("--Mensajeria.helper.updateMensajeriaHP--  id: ", id);
  console.log("--Mensajeria.helper.updateMensajeriaHP--  body: ", JSON.stringify(data));
  const request = await fetch(`${server}${mensajeria}/edit/${id}`, {
    method: "PUT",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(data)
  })
  const response = await request.json();
  console.log("--Mensajeria.helper.updateMensajeriaHP-- response: ", response);
  return response
}

export async function calcularMensajeriaHP(data) {
  console.log("--Mensajeria.helper.calcularMensajeriaHP--  ");
  console.log("--Mensajeria.helper.calcularMensajeriaHP--  data: ", JSON.stringify(data));
  const request = await fetch(`${server}${mensajeria}/calcular`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(data)
  })
  const response = await request.json();
  console.log("--Mensajeria.helper.calcularMensajeriaHP-- response: ", response);
  return response
}

export async function asignarMensajeriaHP(id, data) {
  console.log("--Mensajeria.helper.asignarMensajeriaHP--  ");
  console.log("--Mensajeria.helper.asignarMensajeriaHP-- id: ", id);
  console.log("--Mensajeria.helper.asignarMensajeriaHP--  data: ", JSON.stringify(data));
  const request = await fetch(`${server}${mensajeria}/asignar/${id}`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(data)
  })
  const response = await request.json();
  console.log("--Mensajeria.helper.asignarMensajeriaHP-- response: ", response);
  return response
}

export async function solicitarMensajeriaHP(id) {
  console.log("--Mensajeria.helper.solicitarMensajeriaHP--  ");
  console.log("--Mensajeria.helper.solicitarMensajeriaHP-- id: ", id);
  const request = await fetch(`${server}${mensajeria}/solicitar/${id}`, {
    method: "GET",
    headers: { "content-type": "application/json" }
  })
  const response = await request.json();
  console.log("--Mensajeria.helper.solicitarMensajeriaHP-- response: ", response);
  return response
}

export const getConfig = async () => {
  try {
    const request = await fetch(`${server}${mensajeria}/config`, {
      method: "GET",
      headers: { "content-type": "application/json" }
    })
    console.log(server);
    console.log(process.env.REACT_APP_SERVER);
    return await request.json()

  } catch (error) {
    throw error
  }
}